import { AnalysisDetailContext } from "Components/Analyses/Detail/AnalysisDetailContext";
import { Flex } from "Components/_Shared/Core/Flex";
import { BlDropdown } from "Components/_Shared/Inputs/BlDropdown";
import { StyledLabelAdornment } from "Forms/Components/FormStyles";
import { useSetAnalysisOrganizedBy } from "Infrastructure/ApiZfp/AnalyzerApi";
import { SetOrganizedByBodyOrganizedBy } from "Infrastructure/ApiZfp/Schema/setOrganizedByBodyOrganizedBy";
import type { LookupItem } from "Infrastructure/Models/LookupItem";
import { Spacing } from "Infrastructure/Themes/Themes";
import { Resources, useResource } from "Infrastructure/Translations/Resources";
import { useContext, useEffect, useMemo, useState } from "react";
import { toast } from "sonner";
import { useQuestionnaireContext } from "./QuestionnaireContext";

export const QuestionnaireOrganizedBy = () => {
  const { t } = useResource();
  const { analysisId, versionId } = useContext(AnalysisDetailContext);
  const { organizedBy, isReadOnly } = useQuestionnaireContext();

  const { mutate, isPending: isSaving } = useSetAnalysisOrganizedBy();

  const [value, setValue] = useState<string>(organizedBy);

  useEffect(() => {
    setValue(organizedBy);
  }, [organizedBy]);

  const options = useMemo<LookupItem[]>(
    () => [
      { Value: SetOrganizedByBodyOrganizedBy.client, Name: t(Resources.Questionnaire.OrganizedByOptions.Client) },
      { Value: SetOrganizedByBodyOrganizedBy.agent, Name: t(Resources.Questionnaire.OrganizedByOptions.Agent) },
    ],
    [t],
  );

  const handleChange = (newValue: string | number | string[] | number[]) => {
    if (isSaving) return;
    const organizedBy = newValue as (typeof SetOrganizedByBodyOrganizedBy)[keyof typeof SetOrganizedByBodyOrganizedBy];
    const previous = value;
    setValue(organizedBy);
    mutate(
      { analysisId, versionId, data: { organizedBy } },
      {
        onError: () => {
          setValue(previous);
          toast.error(t(Resources.AnalysisDetail.Toast.ActionError));
        },
      },
    );
  };

  return (
    <Flex width="100%" maxWidth={400} py={Spacing.XXL}>
      <BlDropdown
        label={t(Resources.Questionnaire.OrganizedByWho)}
        options={options}
        value={value}
        labelEndAdornment={<StyledLabelAdornment />}
        onChange={handleChange}
        disabled={isSaving || isReadOnly}
        direction="row"
      />
    </Flex>
  );
};
